import React from 'react';

import { RenderFieldFn } from './RenderFieldFn';
import { isDependencyCheckFails } from './isDependencyCheckFails';

import deleteImg from '../../../assets/images/delete.png';
import { useForm } from '../../../hooks/useForm';

/** Helper function that handles rendering property fields */
export const RenderPropertyFields = (
  currentFeature,
  renderFieldProps,
  owners,
  handleSaveFileProperty,
  activeIndex,
  error,
  removeCreateForm
) => {
  const { getPropertyFields, fileFilterOptions, fileFilter, setFileFilter } = useForm();
  const { data } = renderFieldProps;

  const fields = getPropertyFields(currentFeature, data);
  if (currentFeature?.itemType === 'LicenseProperty') {
    return;
  }
  const subSections =
    currentFeature?.dataType == 'file'
      ? [currentFeature?.section]
      : [
          ...new Set(
            fields
              .sort((field1, field2) => field1.order - field2.order)
              .map((field) => field.subSection)
          ),
        ];
  if (subSections.length > 1) {
    return (
      <>
        {subSections.map((subSection, subIndex) => {
          const subSectionFields = fields
            .filter(
              (field) =>
                field.subSection == subSection &&
                field.type !== 'hidden' &&
                isDependencyCheckFails(field, data, fields)
            )
            .map((field) => {
              if (field.type === 'checkbox') {
                field.style = 'half';
              }
              return field;
            });
          if (subSectionFields.length == 0) return;

          return (
            <div className="subSection" key={'subSection' + subIndex}>
              {subSection && <div className="subSectionTitle">{subSection}</div>}
              <div className={currentFeature?.listStyle ? currentFeature.listStyle : 'form-list'}>
                {subSectionFields
                  .sort((field1, field2) => field1.order - field2.order)
                  .map((field) =>
                    RenderFieldFn(field, renderFieldProps, owners, handleSaveFileProperty, fields)
                  )}
              </div>
            </div>
          );
        })}
        {error && <p className="error-text form-level">{error}</p>}
        {currentFeature?.itemType === 'ApplicantProperty' &&
        owners.length > 0 &&
        activeIndex.sectionIndex == 1 &&
        activeIndex.propertyIndex == 0 ? (
          <div className="remove-owner d-flex" onClick={() => removeCreateForm()}>
            <img src={deleteImg} alt="" />
            <span>Remove this business owner</span>
          </div>
        ) : (
          ''
        )}
      </>
    );
  }

  const renderFileFilters = () => {
    return (
      currentFeature?.dataType == 'file' && (
        <div className="file-filters">
          {fileFilterOptions.map((option) => {
            return (
              <div className={`formCustomCheckBox`} key={`filter-${option}`}>
                <label htmlFor={`filter-${option}`}>
                  <input
                    id={`filter-${option}`}
                    checked={fileFilter == option}
                    name={option}
                    onChange={() => setFileFilter(option)}
                    type="checkbox"
                  />
                  {option}
                </label>
              </div>
            );
          })}
        </div>
      )
    );
  };

  return (
    <>
      <div className={currentFeature?.listStyle ? currentFeature?.listStyle : 'form-list'}>
        {renderFileFilters()}
        {fields
          .filter((field) => {
            if (currentFeature?.dataType == 'file') {
              const fieldValue = data[field.name];
              if (fieldValue?.length && fieldValue[0]?.status == 'WAIVED') {
                // Do not show WAIVED documents
                return false;
              }
              if (fileFilter == 'REQUESTED') {
                return (
                  !fieldValue?.length ||
                  fieldValue[0]?.status == 'REQUESTED' ||
                  fieldValue[0]?.status == 'DECLINED'
                );
              }
              if (fileFilter == 'SUBMITTED') {
                return (
                  fieldValue?.length &&
                  (fieldValue[0]?.status == 'SUBMITTED' ||
                    fieldValue[0]?.status == 'APPROVED' ||
                    fieldValue[0]?.status == 'WAIVED')
                );
              }
            }
            return true;
          })
          .sort((field1, field2) => field1.order - field2.order)
          .map((field) =>
            RenderFieldFn(field, renderFieldProps, owners, handleSaveFileProperty, fields)
          )}
      </div>
      {error && <p className="error-text form-level">{error}</p>}
      {currentFeature?.itemType === 'ApplicantProperty' &&
      owners.length > 0 &&
      activeIndex.sectionIndex == 1 &&
      activeIndex.propertyIndex == 0 ? (
        <div className="remove-owner d-flex" onClick={() => removeCreateForm()}>
          <img src={deleteImg} alt="" />
          <span>Remove this business owner</span>
        </div>
      ) : (
        ''
      )}
    </>
  );
};
